<template>
  <div id="app">
    <Navbar />
    <Main />
    <Projects />
    <About />
  </div>
</template>

<script>
import Main from "@/components/Main";
import Projects from "@/components/Projects";
import Navbar from "@/components/Navbar";
import About from "@/components/About";

export default {
  name: "App",
  components: {
    Main,
    Projects,
    Navbar,
    About,
  },
};
</script>

<style>
html {
  scroll-behavior: smooth;
}
@import "/assets/index.css";
body {
  overflow-x: hidden;
}
</style>
